import React from 'react'
import { Box, Link, Typography } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const TICKET_URL =
  'https://www.eventbrite.com/e/national-equal-shared-parenting-conference-tickets-1988137005302?fbclid=IwY2xjawReXINleHRuA2FlbQIxMABicmlkETFJVUtLSkJWakpQa0g4NmZ5c3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHmsB8Qz25KomD0MRcydTOxuw3JnY0-vmznskiobkzicXDiyAEsAC1Zag9AKp_aem_UU9_QWymQ6XXtLVT1r7woQ'

// Hide on June 30, 2026 and after
const HIDE_AFTER = new Date('2026-06-30T00:00:00')

const AnnouncementBar: React.FC = () => {
  if (new Date() >= HIDE_AFTER) return null

  return (
    <Box
      component="aside"
      aria-label="Event announcement"
      sx={{
        bgcolor: 'secondary.main',
        color: 'white',
        py: { xs: 0.75, sm: 1 },
        px: 2,
        textAlign: 'center',
        width: '100%',
      }}
    >
      <Typography
        variant="body2"
        component="span"
        sx={{
          color: 'white',
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          lineHeight: 1.5,
        }}
      >
        Join us Sunday June 28th at Holiday Inn Washington Capitol - Natl Mall
        by IHG Washington, DC, the Shared Parenting Conference by NCESP.{' '}
        <Link
          href={TICKET_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Buy tickets for the Shared Parenting Conference (opens in new tab)"
          sx={{
            color: 'white',
            fontWeight: 700,
            textDecorationColor: 'rgba(255,255,255,0.7)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.25,
            '&:hover': {
              textDecorationColor: 'white',
            },
          }}
        >
          Buy tickets
          <OpenInNewIcon
            sx={{ fontSize: '0.9em', verticalAlign: 'middle' }}
            aria-hidden="true"
          />
        </Link>
      </Typography>
    </Box>
  )
}

export default AnnouncementBar
